import script from "./RefundRecords.vue?vue&type=script&setup=true&lang=js"
export * from "./RefundRecords.vue?vue&type=script&setup=true&lang=js"

import "./RefundRecords.vue?vue&type=style&index=0&id=2a6dae9e&scoped=true&lang=css"

import exportComponent from "/www/wwwroot/alice/alice_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2a6dae9e"]])

export default __exports__